interface DataTabsHeaderProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  topFocusLine: string;
  copied: boolean;
  onShare: () => void;
}

const ShareIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export default function DataTabsHeader({ eyebrow, title, subtitle, topFocusLine, copied, onShare }: DataTabsHeaderProps) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "1rem", marginBottom: "0.75rem", flexWrap: "wrap" }}>
      <div style={{ maxWidth: "58rem" }}>
        <div style={{ color: "#93c5fd", fontSize: "0.76rem", letterSpacing: "0.14em", textTransform: "uppercase", marginBottom: "0.55rem" }}>
          {eyebrow}
        </div>
        <h1 style={{ color: "var(--color-text)", fontSize: "2.35rem", margin: 0, marginBottom: "0.45rem" }}>
          {title}
        </h1>
        <p style={{ color: "rgba(241, 245, 249, 0.78)", marginBottom: "0.45rem", fontSize: "1.03rem", lineHeight: 1.65 }}>
          {subtitle}
        </p>
        <p style={{ color: "var(--color-text-muted)", margin: 0, fontSize: "0.92rem", lineHeight: 1.6 }}>
          {topFocusLine}
        </p>
      </div>
      <button
        onClick={onShare}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 16px",
          background: copied ? "rgba(16, 185, 129, 0.1)" : "rgba(56, 189, 248, 0.05)",
          border: `1px solid ${copied ? "rgba(16, 185, 129, 0.2)" : "rgba(56, 189, 248, 0.1)"}`,
          borderRadius: "8px",
          color: copied ? "#10b981" : "#38bdf8",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: 600,
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {copied ? <CheckIcon /> : <ShareIcon />}
        {copied ? "Link Copied!" : "Share View"}
      </button>
    </div>
  );
}
